'use client';

import { useSearchParams } from 'next/navigation';

/**
 * Dev-only overlay for pixel-matching against the reference screenshot.
 * Activate by visiting the homepage with ?overlay=1
 * Adjust opacity with ?overlay=0.15 (any float between 0 and 1)
 *
 * The reference image lives at /docs/new_landing.png (served via Next.js public dir
 * — copy it there or update the path below if you serve it differently).
 */
export function OverlayDev() {
  const params = useSearchParams();
  const rawParam = params.get('overlay');

  if (!rawParam) return null;

  /* In production builds this component still exists but the overlay param
     won't be set on real users' URLs so it's effectively a no-op. */
  if (process.env.NODE_ENV === 'production' && rawParam === '1') return null;

  const opacity = parseFloat(rawParam) || 0.25;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[9999]"
      aria-hidden
      style={{
        backgroundImage: 'url(/docs/new_landing.png)',
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        opacity,
        mixBlendMode: 'multiply',
      }}
    />
  );
}
